import React from 'react'
import styles from './clientSec.module.css'
import { clientBanner } from '../../../assets'

const ClientSec = () => {
    return (
        <div className={styles.clientSec_inner}>
            <div className={styles._banner}>
                <img src={clientBanner} alt="" />
            </div>
            <div className={styles._content}>

            </div>
        </div>
    )
}

export default ClientSec
